<template>
  <svg xmlns="http://www.w3.org/2000/svg">
    <defs>
      <radialGradient width="200" height="200px" id="gradient1" cx="50%" cy="50%" r="50%" fx="50%" fy="50%">
        <stop offset="0%" style="stop-color: hsl(207, 90%, 30%); stop-opacity: 1" />
        <stop offset="100%" style="stop-color: hsl(207, 90%, 40%); stop-opacity: 0" />
      </radialGradient>

      <radialGradient id="gradient2" cx="50%" cy="50%" r="50%" fx="50%" fy="50%">
        <stop offset="0%" style="stop-color: hsl(340, 100%, 30%); stop-opacity: 1" />
        <stop offset="100%" style="stop-color: hsl(340, 100%, 40%); stop-opacity: 0" />
      </radialGradient>

      <radialGradient id="gradient3" cx="50%" cy="50%" r="50%" fx="50%" fy="50%">
        <stop offset="0%" style="stop-color: hsl(45, 100%, 30%); stop-opacity: 1" />
        <stop offset="100%" style="stop-color: hsl(45, 100%, 40%); stop-opacity: 0" />
      </radialGradient>
    </defs>

    <!-- <circle cx="100%" cy="100%" r="300" fill="url(#gradient1)" />
    <circle cx="50%" cy="10%" r="80" fill="url(#gradient2)" />
    <circle cx="60%" cy="50%" r="120" fill="url(#gradient3)" /> -->
    <circle id="circle1" cx="0" cy="0" r="1000" fill="url(#gradient1)"/>
    <circle id="circle2" cx="100%" cy="0%" r="1000" fill="url(#gradient2)" />
    <circle id="circle3" cx="0%" cy="100%" r="1000" fill="url(#gradient3)" />
  </svg>
</template>

<style scoped lang="scss">
svg {
  width: 100vw;
  height: 100vh;
  position: absolute;
  top: 0;
  left: 0;
}

circle {
  opacity: 0.8;
  transform-origin: center;
  transform-box: fill-box;
}

#circle1 {
  animation: scaleAnimation 4s ease-in-out infinite;
}
#circle2 {
  animation: scaleAnimation 8s ease-in-out infinite;
}
#circle3 {
  animation: scaleAnimation 12s ease-in-out infinite;
}

@keyframes scaleAnimation {
  0%, 100% {
    transform: scale(1);
    opacity: 0.5;
  }
  50% {
    transform: scale(1.2);
    opacity: 0.1;
  }
}

/* @keyframes moveAnimation {
  0%, 100% {
    transform: translateY(0) translateX(0);
  }
  50% {
    transform: translateY(50vh) translateX(50vw);
  }
} */

/* hsl(207, 90%, 2%), hsl(340, 100%, 2%), hsl(45, 100%, 2%), hsl(122, 39%, 2%) */
</style>